<template>
  <div class="md-product-cart">
    <div class="columns el-cart">
        <div class="column is-3-desktop ">
            <img :src="image"
              class="el-cart-img">
        </div>
        <div class="column is-7-desktop el-cart-section-2">
            <span class="el-cart-section-2-title">
                 {{title}} <br>
            </span>
            <!-- <div class="el-cart-section-2-price">
                 Price : {{price}} THB
            </div> -->
            <div class="el-cart-section-2-amount">
                <!-- <span class="el-cart-section-2-amount-oprt" @click="reduceAmount()">-</span>
                <span class="el-cart-section-2-amount-number">{{
                  amount }}</span>
                <span class="el-cart-section-2-amount-oprt" @click="addAmount()">+</span>
                <span class="el-cart-section-2-unit"> Carton(s)</span> -->
                 <b-field :label-position="labelPosition">
                    <b-numberinput type="is-primary"
                    laceholder='0' :min="1" v-model="amount"
                    icon-pack="fa"
                    controls-position="compact"
                    @input="addAmount()">
                    </b-numberinput>
                </b-field>
                <span class="el-cart-section-2-unit"> Carton(s)</span>
            </div>
        </div>
        <div class="column is-2-desktop has-text-right el-cart-section-3">
            <div class="el-cart-section-3-exit">
               <b-button
                @click="$emit('click')"
                class="el-cart-section-3-desktop"
               >
                   <span class="el-cart-section-3-x">x</span>
               </b-button>
            </div>
            <!-- <div class=" el-cart-section-3-summary">
                {{ amountData * price }}THB
            </div> -->
        </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'ProductCart',
  data() {
    return {
      products: [],
      amountData: 1,
      testamount: 2,
    };
  },
  props: {
    id: {
      type: Number,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    image: {
      type: String,
      required: true,
    },
    price: {
      type: Number,
      default: 0,
    },
    amount: {
      type: Number,
      default: 0,
    },
    index: {
      type: Number,
      default: 0,
    }
  },
  computed: mapState({
    ProductCart: state => state.productCart,
  }),
  created() {
    this.products = this.ProductCart;
    // this.amountData = this.products[this.index].amount.val();
    this.amountData = this.ProductCart[this.index].amount;
  },
  methods: {
    findIndex() {
      return this.products.map(item => item.id).indexOf(this.id);
    },
    removeObj() {
      this.products.splice(this.findIndex(), 1);
    },
    addAmount() {
      this.amountData += 1;
      this.products[this.findIndex()].amount = this.amount;
      this.$store.commit('updateproductCart',
        this.products
      );
    },
    reduceAmount() {
      this.amountData -= 1;
      this.amount = this.amountData;
      this.products[this.findIndex()].amount = this.amountData;
      this.$store.commit('updateproductCart',
        this.products
      );
    },
  },
  filters: {
    formatComma(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
  },
};
</script>

<style lang="scss" scoped>
.el-cart{
    &-section-2{
        line-height: 1.5;
        @media screen and (max-width: 900px) {
          text-align: center;
        }
        &-title{
            font-size: 110%;
            font-weight: bold;
        }
        &-unit{
            font-size: 100%;
            font-weight: bold;
            padding-top:6px;
            padding-left:10px;
        }
        &-price{
            font-size: x-large;
            font-weight: bold;
        }
        &-amount{
            display:inline-flex;
            padding-top: 5%;
            &-oprt{
             border: grey 0.7px solid;
             padding:3px 20px;
             font-size:x-large;
             cursor: pointer;
            }
            &-number{
             border: grey 0.7px solid;
             padding:3px 40px;
             text-align: center;
             font-size: x-large;
            }
        }
    }
    &-img{
      border: 1px solid grey;
    }
    &-section-3{
        position: relative;
        &-summary{
            color:orange;
            font-size: xx-large;
            position: relative;
            bottom: 0;
            right: 0;
            top: 60%;
        }
        &-x{
          font-size: x-large;
          color: white;
        }
        &-desktop{
          background:grey;
        }
    }
}
.md-button-bg{
  padding: 5px 30px 5px 30px;
  background: url("../assets/img/home/button-menu-active.png");
  background-position: center;
}
.md-product-cart {
  padding: 1rem;
  border: grey solid 1px;
  margin-bottom:0.5rem;
  position: relative;

}
</style>
